import i18n from '@/locales';
import { createApp } from 'vue';
import GlobalWebMcp from '@/components/GlobalWebMcp.vue';

const app = createApp(GlobalWebMcp);
app.use(i18n);
app.mount('#globalWebMcpApp');
